import { render, staticRenderFns } from "./PageBlog.vue?vue&type=template&id=5451d4ab&scoped=true&"
import script from "./PageBlog.vue?vue&type=script&lang=js&"
export * from "./PageBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451d4ab",
  null
  
)

export default component.exports